import { CancelButton, Card, CommandButton } from "components"
import { AttachmentModal } from "./AttachmentModal"
import { useParams } from "react-router-dom"
import { useFormContext, useWatch } from "react-hook-form"
import { PaymentInvoiceType } from "../types"
import { Print } from "./Print"

type CommandButtonsProps = {
  approvalView?: boolean
  showDeleteButton?: boolean
  onDelete?: () => void
  onSave?: () => void
}

export const CommandButtons = ({
  approvalView,
  showDeleteButton,
  onDelete,
  onSave
}: CommandButtonsProps) => {
  const { payment_invoice_id } = useParams()

  const { control } = useFormContext<PaymentInvoiceType>()
  const approval_status = useWatch({ control, name: "approve_status" })

  return (
    <Card className={approvalView ? "hidden" : ""}>
      <Card.Body className="flex flex-col gap-5">
        <section className="flex flex-wrap justify-between gap-3">
          <section className="flex flex-wrap gap-3">
            {payment_invoice_id && approval_status === 4 ? <Print /> : <CommandButton actiontype="print" />}
             <AttachmentModal/>
          </section>

          <section className="flex flex-wrap gap-3">
            <CancelButton />
            {approval_status !== 4 && showDeleteButton && (
              <CommandButton actiontype="delete" onClick={onDelete} />
            )}

            {approval_status !== 4 &&
              <CommandButton
                actiontype="save"
                type="button"
                color="primary"
                permission="ST121"
                onClick={onSave}
              />
            }
          </section>
        </section>
      </Card.Body>
    </Card>
  )
}
